import React from 'react';

const TimePicker = ({ value, onChange }) => {
  const [from, to] = value ? value.split(' – ') : ['', ''];
  const [fromTime, fromPeriod] = from ? from.split(' ') : ['', ''];
  const [fromHour, fromMinute] = fromTime ? fromTime.split(':') : ['', ''];
  const [toTime, toPeriod] = to ? to.split(' ') : ['', ''];
  const [toHour, toMinute] = toTime ? toTime.split(':') : ['', ''];

  const handleTimeChange = (part, time, period) => {
    const newTime = `${time} ${period}`;
    if (part === 'from') {
      onChange(`${newTime} – ${to}`);
    } else {
      onChange(`${from} – ${newTime}`);
    }
  };

  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = ['00', '30'];

  return (
    <div className="flex items-center gap-2">
      <select
        value={fromHour}
        onChange={(e) => handleTimeChange('from', `${e.target.value}:${fromMinute}`, fromPeriod)}
        className="p-2 rounded border"
      >
        {hours.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <select
        value={fromMinute}
        onChange={(e) => handleTimeChange('from', `${fromHour}:${e.target.value}`, fromPeriod)}
        className="p-2 rounded border"
      >
        {minutes.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
      <select
        value={fromPeriod}
        onChange={(e) => handleTimeChange('from', fromTime, e.target.value)}
        className="p-2 rounded border"
      >
        <option value="am">am</option>
        <option value="pm">pm</option>
      </select>
      <span>–</span>
      <select
        value={toHour}
        onChange={(e) => handleTimeChange('to', `${e.target.value}:${toMinute}`, toPeriod)}
        className="p-2 rounded border"
      >
        {hours.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <select
        value={toMinute}
        onChange={(e) => handleTimeChange('to', `${toHour}:${e.target.value}`, toPeriod)}
        className="p-2 rounded border"
      >
        {minutes.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
      <select
        value={toPeriod}
        onChange={(e) => handleTimeChange('to', toTime, e.target.value)}
        className="p-2 rounded border"
      >
        <option value="am">am</option>
        <option value="pm">pm</option>
      </select>
    </div>
  );
};

export default TimePicker;
